import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';
import { useTranslation } from 'react-i18next';
import GridOptionsFajlovi from './GridOptionsFajlovi';
import { icons } from '../../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';

const GridProviderFajlovi = ({
  data,
  loading,
  handleOpenFile,
  handleOpenDeleteDialog,
  downloadFile,
  editFile,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: '',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptionsFajlovi
          openFile={() => handleOpenFile(e.row)}
          handleOpenDeleteDialog={() => handleOpenDeleteDialog(e.id)}
          downloadFile={() => downloadFile(e.row.path, e.row.name)}
          editFile={() => editFile(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptionsFajlovi>
      ),
    },
    {
      field: 'name',
      headerName: t('fileName'),
      width: 500,
    },

    {
      field: 'datumDokumenta',
      headerName: t('date'),
      width: 190,
      renderCell: (item) => {
        return (
          <span>
            {item.row.datumDokumenta
              ? formatDateFromDB(item.row.datumDokumenta)
              : null}
          </span>
        );
      },
    },

    {
      field: 'size',
      headerName: t('fileSize'),
      width: 190,
      renderCell: (item) => {
        return <span>{(item.row.size / 1024 ** 2).toFixed(2)} MB</span>;
      },
    },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: '500px',
        width: '99%',
      }}
    >
      <MuiGrid data={data} loading={loading} columns={columns} />
    </div>
  );
};

export default GridProviderFajlovi;
